import { createSelector } from 'reselect';

import { IContactSettingsState } from 'types/contactSettings.types';

const getContactSettings = (state: { contactSettings: IContactSettingsState }) =>
  state.contactSettings;

export const contactSettingsSelector = createSelector(
  [getContactSettings],
  (contactSettings) => contactSettings,
);

export const contactSettingsItemSelector = createSelector(
  [getContactSettings],
  (contactSettings) => contactSettings.item,
);
